export const isSupportCenterShellAvailable = (result) =>
  result?.status === "found" &&
  result.value?.supportCenterEnabled === true &&
  result.value?.shellEnabled === true;
